import { doc, increment, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export interface QRCodeStats {
  totalScans: number;
  lastScan: Date | null;
  created: Date;
}

const qrCodeService = {
  /**
   * Track a QR code scan
   */
  async trackScan(eventId: string): Promise<void> {
    const qrTrackingRef = doc(db, 'qr_codes', `event_${eventId}`);
    
    try {
      await updateDoc(qrTrackingRef, {
        totalScans: increment(1),
        lastScan: new Date()
      });
    } catch (error) {
      console.error('Error tracking QR code scan:', error);
      throw error;
    }
  },

  /**
   * Get QR code statistics
   */
  async getStats(eventId: string): Promise<QRCodeStats | null> {
    const qrTrackingRef = doc(db, 'qr_codes', `event_${eventId}`);
    
    try {
      const doc = await getDoc(qrTrackingRef);
      if (!doc.exists()) {
        return null;
      }
      
      const data = doc.data();
      return {
        totalScans: data.totalScans || 0,
        lastScan: data.lastScan ? new Date(data.lastScan.toDate()) : null,
        created: new Date(data.created.toDate())
      };
    } catch (error) {
      console.error('Error getting QR code stats:', error);
      throw error;
    }
  }
};

export default qrCodeService; 